var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.989 48.7047C29.1438 48.7047 35.7546 42.0939 35.7546 33.9391C35.7546 25.7843 29.1438 19.1735 20.989 19.1735C12.8342 19.1735 6.22339 25.7843 6.22339 33.9391C6.22339 42.0939 12.8342 48.7047 20.989 48.7047Z",
    fill: "#DDE2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9001 9.24213H23.0892C21.132 9.24213 19.5454 10.8287 19.5454 12.7859V57.214C19.5454 59.1712 21.132 60.7578 23.0892 60.7578H46.9001C48.8573 60.7578 50.4438 59.1712 50.4438 57.214V12.7859C50.4438 10.8287 48.8573 9.24213 46.9001 9.24213Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0266 9.24213L28.5141 12.1187C28.6329 12.3403 28.8095 12.5254 29.0253 12.6545C29.241 12.7835 29.4877 12.8516 29.7391 12.8515H40.261C40.5124 12.8516 40.7591 12.7835 40.9748 12.6545C41.1906 12.5254 41.3672 12.3403 41.486 12.1187L42.9735 9.24213H27.0266Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36.5202C39.2224 36.5202 42.6454 33.0973 42.6454 28.8749C42.6454 24.6525 39.2224 21.2296 35 21.2296C30.7777 21.2296 27.3547 24.6525 27.3547 28.8749C27.3547 33.0973 30.7777 36.5202 35 36.5202Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6312 28.6124L33.1625 25.4843C33.117 25.4567 33.0648 25.4418 33.0116 25.4414C32.9583 25.441 32.9059 25.455 32.86 25.4819C32.814 25.5088 32.7762 25.5476 32.7505 25.5942C32.7248 25.6409 32.7122 25.6936 32.714 25.7468V32.0031C32.7155 32.055 32.7302 32.1057 32.7567 32.1505C32.7832 32.1952 32.8206 32.2324 32.8655 32.2587C32.9103 32.2849 32.9611 32.2994 33.0131 32.3006C33.065 32.3018 33.1165 32.2897 33.1625 32.2656L38.6312 29.1374C38.6765 29.1102 38.714 29.0717 38.74 29.0257C38.7661 28.9797 38.7797 28.9278 38.7797 28.8749C38.7797 28.8221 38.7661 28.7701 38.74 28.7241C38.714 28.6781 38.6765 28.6397 38.6312 28.6124Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0219 42.7876H23.8984",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.022 41.0813V44.5047",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 54.9608C36.1659 54.9608 37.111 54.0157 37.111 52.8499C37.111 51.6841 36.1659 50.739 35.0001 50.739C33.8343 50.739 32.8892 51.6841 32.8892 52.8499C32.8892 54.0157 33.8343 54.9608 35.0001 54.9608Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7593 52.8501H43.389",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6108 52.8501H28.2405",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1017 42.7876H31.3032",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDevice);
export default __webpack_public_path__ + "static/media/SmartDevice.af72d2f0751af82970802e7e99485bb5.svg";
export { ForwardRef as ReactComponent };